import axios from 'axios';
import { API_BASE_URL } from '../Config/ApiUrlConstant';

const AUTH_EXPIRED_EVENT = 'thirdwave:auth-expired';

const notifyAuthExpired = () => {
  window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT));
};

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // A 403 means the session is valid but this user lacks access to a feature.
    // Only a 401 should clear the session and redirect to login.
    if (error.response?.status === 401) {
      notifyAuthExpired();
    }

    return Promise.reject(error);
  }
);

export { AUTH_EXPIRED_EVENT };
export default axiosInstance;
